import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Close } from '@mui/icons-material';
import { ActionButtons } from '../others/ActionButtons';
import { RenderFilts } from './RenderFilts';
import { ActionIconItem } from '../others/ActionIconItem';
export const Filter = ({ data, handleFilter }) => {
    const [filters, setFilter] = useState({});
    const [open, setopen] = useState(false);
    const search = () => {
        handleFilter(filters);
        setopen(false);
    }

    const setfilter = (param, param2) => {
        setFilter(prev => ({
            ...prev, [param2]: param
        }));
    }

    const deletefilter = (param) => {
        const newobj = { ...filters };
        delete newobj[param];
        setFilter(newobj);
    }

    return (
        <>
            <Tooltip title={data.accion}>
                <ActionIconItem
                    item={data}
                    onClick={(itemData) => setopen(true)}
                />
            </Tooltip >
            <Dialog
                open={open}
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle>
                    <Typography variant='h5' component='h5'>
                        Filtros
                    </Typography>
                    <IconButton
                        aria-label='close'
                        onClick={() => setopen(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant='body2'>
                                Registro(s) con valor(es) que:
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            {
                                data?.filter
                                    .slice()
                                    .sort((a, b) => (a.type === 'boolean') - (b.type === 'boolean'))
                                    .map((field) => (
                                        <RenderFilts
                                            field={field}
                                            setFilters={setfilter}
                                            deletefilter={deletefilter}
                                        />
                                    ))
                            }
                        </Grid>
                    </Box>
                    <ActionButtons
                        onCancel={() => setopen(false)}
                        onSubmit={search}
                        cancelLabel={"Cancelar"}
                        submitLabel={" Filtar "}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}